<template>
  <div class="card--users">
    <v-row no-gutters>
      <v-col cols="4">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--normal overflow--hidden" v-on="on">
             {{ user.name | userFullName}}
            </span>
          </template>
           <span class="text--normal">{{ user.name | userFullName}}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="4">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--normal lighter overflow--hidden" v-on="on">
             {{ user.department }}
            </span>
          </template>
           <span class="text--normal">{{ user.department }}</span>
        </v-tooltip>
        <span class="text--normal lighter"></span>
      </v-col>
      <v-col cols="4" v-if="user.role && user.role != null">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
           <span class="text--normal lighter overflow--hidden" v-on="on">
             {{ $t('organizations.' + user.role) }}
            </span>
          </template>
           <span class="text--normal">{{ $t('organizations.' + user.role) }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'UsersOverviewCard',
  props: {
    user: Object
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
  .card--users {
    .text--normal {
      font-size: 14px;
      color: #484848;
      font-weight: 500;
      &.overflow--hidden {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 95%;
        display: block;
      }
      &.lighter {
        color: #767676;
      }
    }
  }
</style>
